/**
 * Génère un identifiant
 * inspiré de la conversation https://gist.github.com/gordonbrander/2230317
 */
export function generateId() {
  return `_${Date.now().toString(36)}${Math.random().toString(36).substr(2, 9)}`;
}
